export default __webpack_public_path__ + "static/media/Frame3.04bee5d4.png";